import type { UiSettings } from "../storage.ts";
import { isSubagentSessionKey } from "../../../../src/routing/session-key.js";
import { removeChatOpenTab } from "./chat-tabs.ts";
import { classifySessionCatalogKind } from "./session-catalog.ts";

export function normalizeArchivedSessionKeys(keys: string[] | undefined): string[] {
  const out: string[] = [];
  const seen = new Set<string>();
  for (const raw of keys ?? []) {
    const key = raw.trim();
    if (!key || seen.has(key) || isSubagentSessionKey(key)) {
      continue;
    }
    if (classifySessionCatalogKind(key) === "main") {
      continue;
    }
    seen.add(key);
    out.push(key);
  }
  return out;
}

export function isSessionArchived(settings: UiSettings, sessionKey: string): boolean {
  const key = sessionKey.trim();
  return normalizeArchivedSessionKeys(settings.chatArchivedSessionKeys).includes(key);
}

export function archiveSessionKeys(settings: UiSettings, keys: string[]): UiSettings {
  const merged = normalizeArchivedSessionKeys([
    ...settings.chatArchivedSessionKeys,
    ...keys.map((k) => k.trim()).filter(Boolean),
  ]);
  return { ...settings, chatArchivedSessionKeys: merged };
}

export function unarchiveSessionKeys(settings: UiSettings, keys: string[]): UiSettings {
  const drop = new Set(keys.map((k) => k.trim()).filter(Boolean));
  const next = normalizeArchivedSessionKeys(settings.chatArchivedSessionKeys).filter(
    (k) => !drop.has(k),
  );
  return { ...settings, chatArchivedSessionKeys: next };
}

export function removeArchivedSessionKey(settings: UiSettings, sessionKey: string): UiSettings {
  return unarchiveSessionKeys(settings, [sessionKey]);
}

export function closeArchivedTabKeys(
  openTabs: string[],
  archivedKeys: string[],
  fallbackKey: string,
): string[] {
  let tabs = [...openTabs];
  for (const key of archivedKeys) {
    tabs = removeChatOpenTab(tabs, key, fallbackKey);
  }
  return tabs;
}

export function canArchiveSessionKey(sessionKey: string): boolean {
  const key = sessionKey.trim();
  if (!key || isSubagentSessionKey(key)) {
    return false;
  }
  return classifySessionCatalogKind(key) !== "main";
}
